/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description React Hook useProviderInfo
 */

import { useQuery, UseQueryResult } from '@tanstack/react-query';

import api from 'client/index';
import { getParsedProviderDetails, getProviderPayerMeta } from 'utils/admin/providers';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Use Providers info hook
 * @returns {UseQueryResult} useProviderInfo
 */
const useProviderInfo = (
	providerId: string,
	options?: IQueryOptions,
	cacheKey?: string,
): UseQueryResult<Provider.IResponseModel, IAxiosError> => {
	return useQuery({
		queryKey: [QUERY_KEYS.provider, { providerId, cacheKey }],
		queryFn: async () => {
			const { data } = await api.ProvidersApi.getProvider({ providerId });
			const parsedProviderData: Provider.IResponseModel = {
				...data,
				...getParsedProviderDetails(data?.fhirResource as Fhir.Practitioner | Fhir.Organization),
				providerPayerMeta: getProviderPayerMeta(data?.payerMeta),
			};
			return parsedProviderData;
		},
		enabled: !!providerId,
		...options,
	});
};
export default useProviderInfo;
